import React from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { golfData } from '../../data/mock';

const GolfSection = () => {
  return (
    <section className="py-24 lg:py-32 bg-white" data-testid="golf-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src={golfData.image}
                alt="Golf de Songon"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-6 bg-[#2D5A27] text-white p-8">
              <div className="text-4xl font-light mb-1" style={{ fontFamily: 'Playfair Display, serif' }}>500m</div>
              <div className="text-white/80 text-sm">du Golf</div>
            </div>
          </div>

          {/* Content */}
          <div>
            <p className="text-[#2D5A27] text-sm tracking-[0.2em] uppercase mb-4">
              Proximité privilégiée
            </p>
            <h2 
              className="text-4xl lg:text-5xl text-[#1a1a1a] mb-6 leading-tight"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              {golfData.title}
            </h2>
            <p className="text-[#666] text-lg leading-relaxed mb-8">
              {golfData.description}
            </p>

            {/* Features */}
            <div className="space-y-4 mb-8">
              {golfData.features.map((feature) => (
                <div key={feature} className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-[#2D5A27]/10 flex items-center justify-center">
                    <Check className="w-4 h-4 text-[#2D5A27]" />
                  </div>
                  <span className="text-[#1a1a1a]">{feature}</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <a 
              href="https://legolfdesongon.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#1a1a1a] text-white px-8 py-4 text-sm font-medium tracking-wide hover:bg-[#333] transition-all duration-300"
            >
              Découvrir le Golf de Songon
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GolfSection;
